/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { usePublishedPagesList } from '@api/hooks';

import SearchableEntitySelect from '../SearchableEntitySelect';

const PageSelect = React.forwardRef(({ placeholder = 'Type to search page', ...props }, ref) => (
  <SearchableEntitySelect
    ref={ref}
    placeholder={placeholder}
    useList={usePublishedPagesList}
    formatLabel={({ title }) => title}
    {...props}
  />
));

export default PageSelect;
